import { LitElement, html, css } from './-global.min.js'

class HHBannerVideo extends LitElement {
  static properties = {
    overlayTransparency: {
      type: Number,
    },
    isPlaying: {
      type: Boolean,
      state: true,
      reflect: true,
    },
  }

  constructor() {
    super()
    this.isPlaying = true
    this.overlayTransparency = 0.5
  }

  connectedCallback() {
    super.connectedCallback()
  }

  onClick(e) {
    const videoEl = this.querySelector('video')
    const isPaused = videoEl.paused
    isPaused ? videoEl.play() : videoEl.pause()

    this.isPlaying = isPaused
  }

  static styles = css`
    :host([theme='light']) {
      color: var(--hh-color-reverse);
    }

    :host([theme='dark']) {
      color: var(--hh-color-ink);
    }

    :host .hh-banner-video {
      height: 100%;
      position: relative;
      width: 100%;
    }

    .hh-banner-video__overlay {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      top: 0;
      left: 0;
      right: 0;
      background: var(--banner-video-overlay);
    }

    :host(.overlay-custom-bg) .hh-banner-video__overlay {
      background: var(--hh-overlay-bg);
    }

    .hh-banner-video__controls-container {
      position: absolute;
      display: block;
      bottom: 19px;
      right: 19px;
      z-index: 5;
    }

    .hh-banner-video__controls-btn {
      padding: 0;
      border: none;
      background: none;
      color: inherit;
      cursor: pointer;
    }

    .hh-banner-video__controls-btn[data-state='playing'] .hh-banner__play-icon,
    .hh-banner-video__controls-btn[data-state='paused'] .hh-banner__pause-icon {
      display: none;
    }
  `

  render() {
    return html`
      <div class="hh-banner-video">
        <div class="hh-banner-video__overlay" aria-hidden="true"></div>
        <slot></slot>
        <div class="hh-banner-video__controls-container">
          <button
            type="button"
            class="hh-banner-video__controls-btn"
            aria-label="Toggle video"
            @click="${this.onClick}"
            data-state="${this.isPlaying ? 'playing' : 'paused'}"
          >
            <div class="hh-banner__pause-icon" aria-hidden="true">
              <svg
                width="24"
                height="26"
                viewBox="0 0 24 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.00003 24.2002L7 2.2002"
                  stroke="currentColor"
                  stroke-width="3"
                  stroke-miterlimit="10"
                  stroke-linecap="square"
                />
                <path
                  d="M17 24.2002L17 2.2002"
                  stroke="currentColor"
                  stroke-width="3"
                  stroke-miterlimit="10"
                  stroke-linecap="square"
                />
              </svg>
            </div>
            <div class="hh-banner__play-icon" aria-hidden="true">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.55 12.7 6.17 20.13c-.92.5-2.04-.15-2.04-1.2V4.07a1.38 1.38 0 0 1 2.04-1.2l13.38 7.43c.94.52.94 1.88 0 2.4Z"
                  stroke="currentColor"
                  stroke-width="1.25"
                />
              </svg>
            </div>
          </button>
        </div>
      </div>
    `
  }
}

customElements.define('hh-banner-video', HHBannerVideo)
